/**
 * Historical SGS changelogs were pasted with decorative banners such as
 * `-== 6.65 Release Notes ==--`. Hub display and import strip those lines.
 */

const EQUALS_BANNER_RE = /^\s*-*=+\s+.+\s+=+-*\s*$/;
const DASH_TITLE_BANNER_RE = /^\s*--\s+.+\s+--\s*$/;

export function isFirmwareReleaseNoteBannerLine(line: string): boolean {
  const trimmed = line.trim();
  if (trimmed === "") return false;
  return EQUALS_BANNER_RE.test(trimmed) || DASH_TITLE_BANNER_RE.test(trimmed);
}

export function stripFirmwareReleaseNoteBanners(notes: string): string {
  const lines = notes.replace(/\u00a0/g, " ").replace(/\r\n/g, "\n").split("\n");
  const kept: string[] = [];
  for (const line of lines) {
    if (isFirmwareReleaseNoteBannerLine(line)) continue;
    kept.push(line.replace(/\s+$/g, ""));
  }
  return kept.join("\n").replace(/^\n+/, "").replace(/\n{3,}/g, "\n\n").trim();
}
